import { render } from "./FeaturedProperties.vue?vue&type=template&id=0a7b106c&scoped=true&ts=true"
import script from "./FeaturedProperties.vue?vue&type=script&lang=ts"
export * from "./FeaturedProperties.vue?vue&type=script&lang=ts"

import "./FeaturedProperties.vue?vue&type=style&index=0&id=0a7b106c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7b106c"]])

export default __exports__